export default {"src":"/_next/static/media/foodairy.a8dcf654.svg","height":111,"width":240,"blurWidth":0,"blurHeight":0};